import React, { Component } from "react";

import { Card, Button, Table, Modal, Select, Input, Tooltip } from "antd";

import { connect } from "react-redux";
import {
  req_page_ams_graduatealumni_updatestatus,
  req_downloadfile_ams_graduatealumni_updatestatus,
} from "../../api";
//import { formateDate } from '../../utils/dateUtil'
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { formateDateDbT } from "../../utils/dateUtil";
import AdumniSingleModal from "./alumni-single-modal";
import AdumniEditModal from "./alumni-edit-modal";

class AlumniOneyearNotupdate extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,
    isEditModal: false,
    /*特定參數*/
    searchFieldExtA: "",
    searchFieldExtB: "NONE",
    searchFieldExtC: "NONE",
    searchFieldExtD: "NONE",
    searchFieldExtE: "",
    searchFieldExtF: "NO",
  };

  UNSAFE_componentWillMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      searchFieldExtF,
    } = this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true });
    const result = await req_page_ams_graduatealumni_updatestatus(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      searchFieldExtF
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      searchFieldExtF,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_ams_graduatealumni_updatestatus(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
      searchFieldExtF
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "畢業校友清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "YearGrade",
        width: 35,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "部別",
        dataIndex: "Division",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學制",
        dataIndex: "EducationalSystem",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "系所",
        dataIndex: "DepartmentName",
        width: 80,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "StudentName",
        width: 60,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "最後更新時間",
        dataIndex: "NowStatusModifyDateTime",
        width: 60,
        render: (field) => {
          return (
            <div className="text-center">
              <span> {formateDateDbT(field)}</span>
            </div>
          );
        },
      },
      {
        title: "操作項目",
        dataIndex: "",
        width: 60,
        render: (item) => {
          return (
            <>
              <Button
                type="dashed"
                size="small"
                onClick={() => this.handle_show_ui_modal("view", item)}
              >
                <i className="fas fa-user-alt"></i>{" "}
                <span style={{ marginLeft: "4px" }}>明細</span>
              </Button>
              <Button
                type="dashed"
                size="small"
                onClick={() => this.handle_show_ui_modal("edit", item)}
              >
                <i className="fas fa-user-edit"></i>{" "}
                <span style={{ marginLeft: "4px" }}>修改</span>
              </Button>
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "NowStatusSecondary":
        switch (param) {
          case "尚待確認":
            return "red";
          case "就業":
          case "服役":
          case "升學":
          case "留學":
            return "green";
          case "其他":
            return "purple";
          default:
            return "default";
        }
      default:
        break;
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      default:
    }
  };
  /////////////////////////////////////////////////////////////

  render() {
    const {
      deviceWidth,
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isEditModal,
      isShowModal,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const title = (
      <span>
        <Input
          placeholder="學年度"
          style={{ width: 70, margin: "0 5px" }}
          value={searchFieldExtA}
          onChange={(event) =>
            this.setState({ searchFieldExtA: event.target.value })
          }
        />
        {deviceWidth > 1200 ? (
          <>
            <Select
              value={searchFieldExtC}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtC: value })}
            >
              <Select.Option value="NONE">部別</Select.Option>
              <Select.Option value="日間部">日間部</Select.Option>
              <Select.Option value="進修部">進修部</Select.Option>
              <Select.Option value="在職專班">在職專班</Select.Option>
              <Select.Option value="假日專班">假日專班</Select.Option>
            </Select>
            <Select
              value={searchFieldExtB}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtB: value })}
            >
              <Select.Option value="NONE">學制</Select.Option>
              <Select.Option value="四技">四技</Select.Option>
              <Select.Option value="二技">二技</Select.Option>
              <Select.Option value="七技">七技</Select.Option>
              <Select.Option value="研究所">研究所</Select.Option>
              <Select.Option value="二專">二專</Select.Option>
              <Select.Option value="三專">三專</Select.Option>
              <Select.Option value="五專">五專</Select.Option>
            </Select>
            <Select
              value={searchFieldExtD}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtD: value })}
            >
              <Select.Option value="NONE">學院</Select.Option>
              <Select.Option value="生活科技學院">生活科技學院</Select.Option>
              <Select.Option value="旅遊學院">旅遊學院</Select.Option>
              <Select.Option value="藝術學院">藝術學院</Select.Option>
              <Select.Option value="管理學院 ">管理學院</Select.Option>
              <Select.Option value="設計學院 ">設計學院</Select.Option>
            </Select>
            <Input
              placeholder="科系"
              style={{ width: 150, margin: "0 5px" }}
              value={searchFieldExtE}
              onChange={(event) =>
                this.setState({ searchFieldExtE: event.target.value })
              }
            />
          </>
        ) : (
          ""
        )}
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="StudentId">畢業生學號</Select.Option>
          <Select.Option value="StudentName">畢業生姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i> 查詢
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        {deviceWidth > 600 ? (
          <>
            <Button type="primary" onClick={() => this.handle_data_download()}>
              <i className="fas fa-cloud-download-alt element-hidden"></i> 下載
            </Button>
          </>
        ) : (
          ""
        )}
      </span>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          title="查詢基本資料"
          visible={isShowModal}
          width={1000}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <AdumniSingleModal alumni={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          title="修改基本資料"
          visible={isEditModal}
          width={1000}
          onOk={() => {
            this.setState({ isEditModal: false });
          }}
          onCancel={() => {
            this.setState({ isEditModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <AdumniEditModal alumni={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AlumniOneyearNotupdate);
